import actionTypes from 'redux/actions/actionTypes'

const defaultState = {
	notifications: {
		isEmailEnabled: false,
	},
}

function setNotificationPreferences(state, action) {
	return {
		...state,
		notifications: {
			...state.notifications,
			isEmailEnabled: action.notifications.isEmailEnabled,
		},
	}
}

function updateEmailNotification(state, action) {
	return {
		...state,
		notifications: {
			isEmailEnabled: action.value,
		},
	}
}

const navigationMenuReducer = (state = defaultState, action) => {
	switch (action.type) {
		case actionTypes.NAVIGATION_MENU_NOTIFICATION_PREFERENCES_FETCHED:
			return setNotificationPreferences(state, action)
		case actionTypes.NAVIGATION_MENU_NOTIFICATION_PREFERENCES_EMAIL_NOTIFICATION_ENABLED:
			return updateEmailNotification(state, action)
		default:
			return state
	}
}

export default navigationMenuReducer
